module.exports = __webpack_public_path__ + "img/img3.42834cb5.png";